module.exports = "/_next/static/images/ActivateEngagement-16ef09da36c631959c46b23d39923396.webp";